import L from 'leaflet';
const MAPTILER_KEY = import.meta.env.VITE_MAPTILER_KEY;
/**
 * Fond de carte : MapTiler (usage commercial autorisé, clé restreinte au
 * domaine dans le tableau de bord MapTiler) ; OpenStreetMap en développement.
 */
export function createBaseLayer() {
    if (MAPTILER_KEY) {
        return L.tileLayer(`https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=${MAPTILER_KEY}`, {
            attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap</a>',
            maxZoom: 20,
            crossOrigin: true,
        });
    }
    return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap',
        maxZoom: 19,
    });
}
export const QUEBEC_CENTER = [46.81, -71.2];
//# sourceMappingURL=map.js.map